import { Box, Card, CardContent, Grid } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import {
  Body,
  SkillBody,
} from "../assets/styles/styled-components/GlobalStyles";
import { Link } from "react-router-dom";
import Slider from "../components/Slider";

export default function Skill() {
  const collapsed = useSelector((state) => state.sidebar.isCollaped);

  return (
    <Body isCollapsed={collapsed}>
      <SkillBody>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: "100vh" }}
          spacing={{ xs: 3, sm: 5, md: 8, lg: 10, xl: 20 }}
        >
          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
            <h2>Skills & Experience</h2>
          </Grid>
          <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
              <Slider />
              <Grid container spacing={5} direction="row">
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" className="card">
                    <CardContent>
                      <h3>Full stack developer</h3>
                      <h6>
                        WEDO, SCG
                        <br />
                        Jun 2022 - Aug 2022
                      </h6>
                      <p>
                        Developed app services (mobile & website) and IoT smart
                        outlet for residents who want to use electricity in a
                        public area called "meplug".
                      </p>
                      <Link
                        to="/projects/meplug"
                        style={{
                          textDecoration: "none",
                          color: "#BF3699",
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        View more
                      </Link>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" className="card">
                    <CardContent>
                      <h3>Freelance developer</h3>
                      <h6>
                        Home
                        <br />
                        Apr 2022 - Present
                      </h6>
                      <p>Develop website and mobile application.</p>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
          </Grid>
        </Grid>
      </SkillBody>
    </Body>
  );
}
